import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function requireMinOneColleagueValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const coleagues = control.value;
        if (coleagues && coleagues.length > 0) {
            console.log(coleagues);
            return null;
        }
        return { required: true };
    };
}
